import RelevancyRenderer from '../_components/RelevancyRenderer';

export const scrapeDataConfig = ({ setCurrentRowData, setIsOpen, isOpen }) => [
  {
    headerName: 'ID',
    field: 'id',
    resizable: false,
    width: 100,
    sortable: true,
  },
  {
    headerName: 'Job Link',
    field: 'job_link',
    resizable: true,
    sortable: true,
    tooltipField: 'job_link', // Shows full URL on hover
    cellRenderer: (params) => {
      const url = params.value;
      if (!url) return 'N/A';

      return (
        <a
          href={url}
          target='_blank'
          rel='noopener noreferrer'
          style={{ color: '#1a73e8' }}
        >
          {url.length > 50 ? `${url.substring(0, 50)}...` : url}
        </a>
      );
    },
  },
  {
    headerName: 'Role Name',
    field: 'role_name',
    resizable: true,
    sortable: true,
    tooltipField: 'role_name', // Simple tooltip showing the same field
  },
  {
    headerName: 'Company Name',
    field: 'company_name',
    resizable: true,
    sortable: true,
    tooltipField: 'company_name',
  },
  {
    headerName: 'Location',
    field: 'job_location',
    resizable: true,
    sortable: true,
    tooltipField: 'job_location',
  },
  {
    headerName: 'Posted At',
    field: 'job_post_at',
    resizable: true,
    sortable: true,
    valueFormatter: (p) =>
      p.value ? new Date(p.value).toLocaleString() : 'N/A',
    tooltipValueGetter: (p) =>
      p.value
        ? `Posted: ${new Date(p.value).toLocaleString()}`
        : 'No date available',
  },
  {
    headerName: 'Description',
    field: 'description',
    resizable: true,
    sortable: false,
    tooltipField: 'description', // Shows full description on hover
    cellRenderer: (params) => {
      const desc = params.value || '';
      // Truncate description for display but show full text on hover
      return desc.length > 100 ? `${desc.substring(0, 100)}...` : desc;
    },
  },
  {
    headerName: 'Skills',
    field: 'skills',
    resizable: true,
    sortable: false,
    valueFormatter: (p) =>
      Array.isArray(p.value) && p.value.length > 0 ? p.value.join(', ') : 'N/A',
    tooltipValueGetter: (p) => {
      if (Array.isArray(p.value) && p.value.length > 0) {
        return `Skills: ${p.value.join(', ')}`;
      }
      return 'No skills listed';
    },
  },
  {
    headerName: 'Experience',
    field: 'experience',
    resizable: true,
    sortable: true,
    tooltipField: 'experience',
  },
  {
    headerName: 'Salary',
    field: 'salary',
    resizable: true,
    sortable: true,
    tooltipField: 'salary',
  },
  {
    headerName: 'Employment Type',
    field: 'employment_type',
    resizable: true,
    sortable: true,
    tooltipField: 'employment_type',
  },
  {
    headerName: 'Seniority',
    field: 'seniority',
    resizable: true,
    sortable: true,
    tooltipField: 'seniority',
  },
  {
    headerName: 'Job Function',
    field: 'jobFunction',
    resizable: true,
    sortable: true,
    tooltipField: 'jobFunction',
  },
  {
    headerName: 'Industry',
    field: 'industries',
    resizable: true,
    sortable: true,
    tooltipField: 'industries',
  },
  {
    headerName: 'Vacancy',
    field: 'vacancy',
    resizable: true,
    sortable: true,
    valueFormatter: (p) => (p.value != null ? p.value : 'N/A'),
    tooltipValueGetter: (p) =>
      p.value != null
        ? `Vacancies: ${p.value}`
        : 'Vacancy information not available',
  },
  {
    headerName: 'Relevant',
    field: 'relevant',
    resizable: true,
    sortable: true,
    tooltipField: 'relevant',
  },
  {
    headerName: 'Feedback',
    field: 'feedback',
    resizable: true,
    sortable: true,
    tooltipField: 'feedback', // Important for feedback which can be long
  },
  {
    headerName: 'Created At',
    field: 'created_at',
    resizable: true,
    sortable: true,
    valueFormatter: (p) =>
      p.value ? new Date(p.value).toLocaleString() : 'N/A',
    tooltipValueGetter: (p) =>
      p.value
        ? `Created: ${new Date(p.value).toLocaleString()}`
        : 'Creation date not available',
  },
  {
    headerName: 'Updated At',
    field: 'updated_at',
    resizable: true,
    sortable: true,
    valueFormatter: (p) =>
      p.value ? new Date(p.value).toLocaleString() : 'N/A',
    tooltipValueGetter: (p) =>
      p.value
        ? `Last updated: ${new Date(p.value).toLocaleString()}`
        : 'Update date not available',
  },
  {
    headerName: 'Scraping Input ID',
    field: 'scraping_input_id',
    resizable: false,
    width: 150,
    sortable: true,
    tooltipField: 'scraping_input_id',
  },
  {
    headerName: 'Actions',
    field: 'relevancy',
    pinned: 'right',
    resizable: true,
    width: 330,
    sortable: false,
    cellRenderer: RelevancyRenderer,
    cellRendererParams: {
      setCurrentRowData,
      setIsOpen,
      isOpen,
    },
    // Custom tooltip for relevancy actions
    tooltipValueGetter: (p) => 'Click to view relevancy options',
  },
];
